import { lazyGetMyDayMenuSections } from 'owa-mail-ribbon-sections/lib/sections';
import type { MailboxInfo } from 'owa-client-types';
import { setMenuDefinition } from '../../mutatorActions/setMenuDefinition';

export const onMyDayMenuClicked = (mailboxInfo: MailboxInfo): void => {
    lazyGetMyDayMenuSections.import().then(getMyDayOptionsSections => {
        setMenuDefinition(
            'MyDayOptionsMenuDefinitionStore',
            undefined /* projectionTabId */,
            () => {
                return {
                    sections: getMyDayOptionsSections(mailboxInfo),
                };
            }
        );
    });
};
